export const Z_INDEX = {
  BACKGROUND: 1,
  FILTER: 5,
  CONTENT: 10,
  NAV: 100,
  DESKTOP_VIDEO: 101,
  DESKTOP_BUTTON: 102,
  MODAL_BACKGROUND: 110,
  MODAL: 120,
}
